export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MANGA ATAULFO.dc3895da.pdf";